<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12 pl-6 pt-6 pr-6>
                    <v-layout row wrap justify-end>
                        <v-menu v-model="menuDate" :close-on-content-click="false"  transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                :disabled="tuikuan.ID > 0"
                                v-model="computedDateFormatted"
                                label="Ngày"
                                hint="DD-MM-YYYY"
                                persistent-hint
                                prepend-icon="fa-calendar-alt"
                                readonly
                                v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="orderDate" no-title @input="menuDate = false"></v-date-picker>
                        </v-menu>
                    </v-layout>
                </v-flex>
                <v-flex lg6 md6 sm12 pl-4>
                    <h-currency-input v-model="tuikuan.OrderAmount" :decimal="2" label="Tiền hoàn lại (¥)" class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg6 md6 sm12>
                    <v-text-field v-model="tuikuan.OrderCode" label="Mã đơn hàng" class="input-group--focused"></v-text-field>
                </v-flex>                
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import configs from "@/configs";
export default {
    data() {
        return {
            menuDate: false,
            orderDate: moment.utc(Date.now()).toISOString().substr(0, 10)
        };
    },
    computed: {
        ...mapState({
            loading: state => state.tuikuan.loading,
            tuikuan: state => state.tuikuan.selected
        }),
        modifyId() {
            return this.$route.params.Pid;
        },
        computedDateFormatted () {
            return this.tuikuan.OrderDate && this.tuikuan.ID > 0 ? moment.utc(this.tuikuan.OrderDate).format(configs.SHORT_DATE_FORMAT) : moment.utc(this.orderDate).format(configs.SHORT_DATE_FORMAT);
        },
    },
    watch: {
        modifyId() {
            this.refreshData();
        },
        tuikuan() {
            if(this.tuikuan && this.tuikuan.OrderDate > 0) {
                this.orderDate = moment.utc(this.tuikuan.OrderDate).toISOString().substr(0, 10)
            } 
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("tuikuan/getDetail", this.modifyId);
            }
            else {
                this.$store.commit("tuikuan/setDetail", { data: {
                        OrderDate: moment.utc(Date.now()),
                        OrderAmount: 0,
                        Status: 0
                    }
                })
            }
        },
        saveData() {
            this.$store.dispatch("tuikuan/setDetail", {
                data: {
                    ...this.tuikuan,
                    OrderDate: this.orderDate
                },
                id: this.tuikuan.ID
            });
            window.getApp.$emit("APP_NAVIGATE", "TuiKuanList");
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refreshData);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.refreshData);
    },
};
</script>